module.exports = __webpack_public_path__ + "static/media/dashboard_bgd.cae0d118.png";